module.exports = __webpack_public_path__ + "media/images/convenios/2014-03-27-C3-641146-d796a1009ca4a3be92c9eaec443ef435.jpg";